function filterData(val, data) {
  const filteredData = data.filter((proizvod) =>
    proizvod.imeProizvoda.toLowerCase().includes(val.toLowerCase())
  )
  return filteredData
}

export { filterData }
